import { render } from "./add-new-hires.vue?vue&type=template&id=5d353451&lang=pug"
import script from "./add-new-hires.vue?vue&type=script&lang=js"
export * from "./add-new-hires.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__